import React from "react";
import { IInsights } from "./InsightsController";
import ICImage from "../../core-component/ICImage";
import { getRelativeTime } from "../../utils/AppFunctions";
import { externalLinkIcon } from "../../assets/icons/SvgIconList";
import { useNavigate } from "react-router-dom";
import ICPureImage from "../../core-component/ICPureImage";
import PublicRouter, { publicRoute } from "../../routes/RoutePublic";
interface IInsightCardProps {
  item: IInsights;
}
const InsightCard: React.FC<IInsightCardProps> = ({ item }) => {
  const navigate = useNavigate();
  const handleView = (slug: string, id: number) => {
    navigate(`/${publicRoute.insightDetail}/${id}/${slug}`, {
      state: { id: id, slug: slug },
    });
  };
  const handleViewDetails = (slug: string, id: number) => {
    const url = `/${publicRoute.insightDetail}/${id}/${slug}`;
    window.open(url, "_blank");
  };
  const truncateText = (text: string, maxLength: number): string => {
    if (text.length <= maxLength) {
      return text;
    } else {
      return text.substring(0, maxLength);
    }
  };
  const extractPlainText = (html: string): string => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };
  let splitStrings: string[];
  return (
    <div className="xl:col-span-4 transition-all duration-200 lg:col-span-4 md:col-span-4 col-span-12 h-full">
      <div className="bg-skin-insights-card shadow-inner !rounded-[10px]  overflow-hidden h-full">
        <div
          className="cursor-pointer"
          onClick={() => handleView(item.slug, item.id)}
        >
          <ICPureImage
            // loadingClassName="p-12"
            wrapperClassName="w-full transition-all duration-200 aspect-[16/9] hover:scale-105 hover:opacity-60"
            className="w-full aspect-[16/9] object-contain"
            imageUrl={item.cover_image ?? ""}
          />
        </div>
        <div className="p-4 h-full">
          <div className="flex my-4 items-center">
            <div className=" rounded-full overflow-hidden p-2 ">
              <ICImage
                className="!w-10 !h-10 object-cover rounded-full"
                imageUrl={item?.profile_url}
              />
            </div>
            <div className="ml-2">
              <div className="text-sm text-skin-insights">
                {item.created_by}
              </div>
              <div className="text-sm text-skin-insights">
                {item.created_date
                  ? getRelativeTime(item.created_date.toString())
                  : ""}
              </div>
            </div>
          </div>
          {item.blog_categories && (
            <div className="flex gap-4 overflow-x-scroll">
              {item.blog_categories.length > 0 &&
                item.blog_categories.split(",").map((category, index) => (
                  <div
                    key={index}
                    className=" text-[12px] flex-shrink-0 !rounded-[10px] border-2 !border-[#99b5a1] p-2 w-fit text-skin-title-insights"
                  >
                    {category}
                  </div>
                ))}
            </div>
          )}
          <div className=" flex justify-between my-4 ">
            <div className="text-2xl font-semibold text-skin-title-insights mb-2">
              {item.blog_title}
            </div>
            <div>
              <div className="text-skin-icon-insights hover:text-skin-hover-icon-insights font-semibold">
                <div
                  className="h-5 w-5 cursor-pointer"
                  onClick={() => handleViewDetails(item.slug, item.id)}
                >
                  {externalLinkIcon}
                </div>
              </div>
            </div>
          </div>
          <div className="my-4">
            <div className="text-sm text-skin-dec-insights leading-6 mb-4">
              {truncateText(extractPlainText(item.blog_content), 200)}...
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsightCard;
